import { CategoryDetailsBellow as AdvoxBasicCategoryDetailsBellow } from 'AdvoxBasicComponent/CategoryDetailsBellow/CategoryDetailsBellow.component';

import './CategoryDetailsBellow.extend.style';

/** @namespace AdvoxStrigob2c/Component/CategoryDetailsBellow/Component/CategoryDetailsBellow */
export class CategoryDetailsBellow extends AdvoxBasicCategoryDetailsBellow {
    renderCategoryName() {
        const {
            category: { name, id },
        } = this.props;

        if (id && !name) {
            return null;
        }

        return (
            <p block="CategoryDetailsBellow" elem="Heading">
                {this.renderCategoryText()}
            </p>
        );
    }
}

export default CategoryDetailsBellow;
